export class Explotacion {
  Codigo: string;
  Descripcion: string;
  Domicilio: string;
  Contacto: string;
  Horario: string;
  Sociedad: string;
  Email: string;
  CondicionesEnvio: string;
  PoliticaEnvio: string;
  Estado: string;
  EstadoInfo: string;
  EstadoNoDisManMensaje: string;
  EstadoDisManMensaje: string;
  EstadoDisManMenFechaInicio?: Date;
  EstadoDisManMenFechaFin?: Date;
  EstadoRedireccionURL: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/explotacion.entity.ts